import React from "react";

import { Button } from "../../shadcn/components/ui/button";
import { Spinner } from "../../shadcn/components/ui/spinner";

// Button that shows a spinner (in place of its icon) and is disabled while busy.
const LoadingButton = React.forwardRef(function LoadingButton(
  { loading = false, disabled, icon, children, ...props },
  ref
) {
  return (
    <Button
      ref={ref}
      {...props}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
    >
      {loading ? <Spinner aria-hidden="true" /> : icon}
      {children}
    </Button>
  );
});

export default LoadingButton;
